var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTagBookmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 0L6.46946 2.97746L9.75528 3.45492L7.37764 5.77254L7.93893 9.04508L5 7.5L2.06107 9.04508L2.62236 5.77254L0.244718 3.45492L3.53054 2.97746L5 0Z",
    fill: "#450862"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagBookmark);
export default __webpack_public_path__ + "static/media/tag_bookmark.9a793be46c1430fdb9c2fdc00ca3fedd.svg";
export { ForwardRef as ReactComponent };